import Config from '../constants/Config';

export default {
    BASE_LAWYER_TARIFF_FACTOR: 0.5,
    ADDITIONAL_LAWYER_TARIFF_FACTOR_PER_DEPOT_HOLDER: 0.3,
    BASE_COURT_FEE_FACTOR: 0.5,
    MIN_COURT_FEE: 15,
    STANDARD_LAWYER_EXPENSES: 20,
    VAT_FACTOR: 1.19,
    FEE_LEVELS: [
        {
            lowerLimit:     0,
            upperLimit:     500,
            step:           500,
            lawyerTariff:   49,
            courtFee:       38
        },
        {
            lowerLimit:     500,
            upperLimit:     2000,
            step:           500,
            lawyerTariff:   39,
            courtFee:       20
        },
        {
            lowerLimit:     2000,
            upperLimit:     10000,
            step:           1000,
            lawyerTariff:   56,
            courtFee:       21
        },
        {
            lowerLimit:     10000,
            upperLimit:     25000,
            step:           3000,
            lawyerTariff:   52,
            courtFee:       29
        },
        {
            lowerLimit:     25000,
            upperLimit:     50000,
            step:           5000,
            lawyerTariff:   81,
            courtFee:       38
        },
        {
            lowerLimit:     50000,
            upperLimit:     200000,
            step:           15000,
            lawyerTariff:   94,
            courtFee:       132
        },
        {
            lowerLimit:     200000,
            upperLimit:     500000,
            step:           30000,
            lawyerTariff:   132,
            courtFee:       198
        },
        {
            lowerLimit:     500000,
            upperLimit:     Config.MAX_COST_LIMIT,
            step:           50000,
            lawyerTariff:   165,
            courtFee:       198
        },
    ],
    calculateCosts(countDepotHolder, objectValue)
    {
        let fees = this.calculateLawyerTariffAndCourtFee(objectValue);
        let lawyerTariff = fees.lawyerTariff;
        let courtFee = fees.courtFee;

        let lawyerTariffFactor = this.BASE_LAWYER_TARIFF_FACTOR + this.ADDITIONAL_LAWYER_TARIFF_FACTOR_PER_DEPOT_HOLDER * countDepotHolder;
        let calculatedLawyerFee = lawyerTariff * lawyerTariffFactor;

        let calculatedCourtFee = Math.max(courtFee * this.BASE_COURT_FEE_FACTOR, this.MIN_COURT_FEE);

        let costs = ((calculatedLawyerFee + this.STANDARD_LAWYER_EXPENSES) * this.VAT_FACTOR) + calculatedCourtFee;

        return this.round(costs);
    },
    calculateCostRatio(costs, objectValue)
    {
        let costRatio = (costs / (objectValue + costs)) * 100;
        
        return this.round(costRatio);
    },
    calculateLawyerTariffAndCourtFee(objectValue)
    {
        //Calculate lawyer tariff and court fees
        //Lower limits of the feelevels are excluded and upper limits included
        let lawyerTariff = 0;
        let courtFee = 0;
        let feeLevels = this.FEE_LEVELS.filter(level => objectValue > level.lowerLimit);
        let calculationStartValue = 0;

        for (let i = 0; i < feeLevels.length; i++)
        {
            let currentLevel = feeLevels[i];
            let objectValueCurrent = calculationStartValue;
            let upperLimit = Math.min(objectValue, currentLevel.upperLimit);
            while (objectValueCurrent < upperLimit)
            {
                lawyerTariff += currentLevel.lawyerTariff;
                courtFee += currentLevel.courtFee;
                objectValueCurrent += currentLevel.step;
            }

            calculationStartValue = currentLevel.upperLimit;
        }
        
        return {
            lawyerTariff: lawyerTariff,
            courtFee: courtFee
        };
    },
    round(value)
    {
        return Math.round( value * 100 + Number.EPSILON ) / 100  ;
    }
}